export const getLocationAddress = (location) => {
  if (!location) return null;
  if (typeof location === 'string') return location;
  if (typeof location === 'object') {
    if (typeof location.address === 'string' && location.address.trim()) {
      return location.address;
    }
    // Legacy / websocket payloads: { position: { lat, lng } } without address
    if (typeof location.name === 'string' && location.name.trim()) {
      return location.name;
    }
  }
  return null;
};

export const getRideDestination = (ride = {}) =>
  getLocationAddress(ride.destination) ||
  getLocationAddress(ride.dropoff) ||
  getLocationAddress(ride.destination_address) ||
  'N/A';

export const getRidePickup = (ride = {}) =>
  getLocationAddress(ride.pickup) ||
  getLocationAddress(ride.pickup_address) ||
  'N/A';

/** ISO timestamp for when the trip is scheduled (pickup), if any. */
export const getRideScheduledAt = (ride = {}) =>
  ride.scheduled_for || ride.scheduled_time || ride.pickup_time || null;

export const isScheduledRide = (ride = {}) =>
  ride.status === 'scheduled' || !!getRideScheduledAt(ride);
